import React, { Fragment } from 'react';
import { Text, View } from '@react-pdf/renderer';
import intl from 'react-intl-universal';
import { styles } from './styles';
import PropTypes from 'prop-types';
import { KEY_LABELS, getValueFromLabel, LABELS } from './constants';

const propTypes = {
  reportContent: PropTypes.object.isRequired,
};

const ReportDescription = ({ reportContent }) => {
  const { content } = reportContent;

  return (
    <Fragment>
      <View style={styles.reportSectionTitle}>
        <Text>{intl.get(KEY_LABELS[LABELS.DESCRIPTION])}</Text>
      </View>
      <View style={styles.reportSectionContent}>
        <Text>
          {getValueFromLabel(content, KEY_LABELS[LABELS.DESCRIPTION])}
        </Text>
      </View>
    </Fragment>
  );
};

ReportDescription.propTypes = propTypes;

export default ReportDescription;
